import React from "react";
import { SaveStatus } from "../hooks/useFormBuilder";

// Format time as "HH:MM"
const formatTime = (date: Date) => {
	return date.toLocaleTimeString("de-DE", {
		hour: "2-digit",
		minute: "2-digit",
	});
};

// SaveStatusIndicator component
const SaveStatusIndicator = ({
	status,
	lastSaved,
}: {
	status: SaveStatus;
	lastSaved: Date | null;
}) => {
	let content;

	switch (status) {
		case "saved":
			content = (
				<span className="text-gray-500">
					{lastSaved
						? `Gespeichert ${formatTime(lastSaved)}`
						: "Gespeichert"}
				</span>
			);
			break;

		case "saving":
			content = (
				<span className="text-gray-600 italic">
					Wird gespeichert...
				</span>
			);
			break;

		case "unsaved":
			content = (
				<span className="text-gray-600 italic">
					Ungespeicherte Änderungen
				</span>
			);
			break;

		case "error":
			content = (
				<span className="text-red-500">Fehler beim Speichern</span>
			);
			break;
	}

	return <div className="text-xs">{content}</div>;
};

export default SaveStatusIndicator;
